<template>
  <div class="changeCurrentFeed">
    <div class="updateTypeHeader">
      <div class="updateTypeHeader-saveHolder">
        <button-com
          iconName="check"
          iconSize="small"
          text="Update"
          class="bm-confirm"
          @click.native="update"
        ></button-com>
      </div>
      <div class="updateTypeHeader-closeHolder">
        <button-com
          iconName="close"
          iconSize="large"
          iconColor="#D0D0D0"
          iconCircleColor="#D0D0D0"
          tooltip="Cancel"
          class="bm-ghost bm-onlyIcon"
          @click.native="cancel"
        ></button-com>
      </div>
    </div>
    <contentgroup-com>
      <div class="changeCurrentFeed-column">
        <div class="changeCurrentFeed-name">Plural <span>- ex. Pages</span></div>
        <div class="changeCurrentFeed-field">
          <input type="text" v-model="plural" placeholder="...">
        </div>
      </div>
      <div class="changeCurrentFeed-divider"></div>
      <div class="changeCurrentFeed-column">
        <div class="changeCurrentFeed-name">Singular <span>- ex. Page</span></div>
        <div class="changeCurrentFeed-field">
          <input type="text" v-model="singular" placeholder="...">
        </div>
      </div>
    </contentgroup-com>
    <contentgroup-com marginBottom="300">
      <datatypes-com :currentDataTypes="dataTypes" @dataTypes="setDataTypes($event)"></datatypes-com>
    </contentgroup-com>
  </div>
</template>

<script>

import AddnewtypeheaderCom from '@/components/AddNewTypeHeader'
import DatatypesCom from '@/components/DataTypes'

export default {
  components: {
    AddnewtypeheaderCom,
    DatatypesCom
  },
  computed: {
    saveable () {
      return !!this.plural && !!this.singular && !!this.dataTypes.length
    },
    feeds () {
      return this.$store.state.feeds
    },
    feed () {
      return this.$store.state.feeds[this.currentFeed]
    },
    currentFeed () {
      return this.$store.state.currentFeed
    }
  },
  methods: {
    updateFeedHeader (key, value) {
      this.$store.commit({
        type: 'updateFeedHeader',
        key: key,
        value: value,
        feedGroupIndex: this.currentFeed,
        feedIndex: 0
      })
    },
    cancel () {
      this.$router.push('/')
    },
    update () {
      this.updateFeedHeader('plural', this.plural)
      this.updateFeedHeader('singular', this.singular)
      this.updateFeedHeader('template', this.dataTypes)
      this.$http.post(
        'http://api.lootbox.se/saveChanges',
        {
          feeds: JSON.stringify(this.feeds)
        },
        {
          emulateJSON: true,
          withCredentials: true
        }
      ).then(() => {
        this.$router.push('/')
      }, () => {
        console.log('Fail!')
      })
    },
    setDataTypes (dataTypes) {
      this.dataTypes = dataTypes
    }
  },
  data () {
    return {
      plural: '',
      singular: '',
      dataTypes: []
    }
  },
  created () {
    this.plural = this.feed[0].plural
    this.singular = this.feed[0].singular
    this.dataTypes = this.feed[0].template
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('updateTypeHeader')
  height: 100px
  display: flex
  align-items: center
  max-width: 708px
  margin: 0 auto
  position: relative
  padding: 0 30px

  +element('closeHolder')
    position: absolute
    right: 30px
    display: flex

  +element('saveHolder')
    position: absolute
    left: 50%
    transform: translateX(-50%)

+block('changeCurrentFeed')
  width: 100%
  height: calc(100% + 70px)

  +element('column')
    width: 100%

  +element('divider')
    width: 25px

  +element('name')
    padding-top: 9px
    padding-left: 25px
    text-transform: capitalize
    font-size: 12px
    margin-bottom: 12px

    span
      opacity: .5

</style>



// WEBPACK FOOTER //
// src/routerViews/ChangeCurrentFeed.vue